// Один Comlink-прокси к Worker'у. Импорт через `?worker` даёт Vite-обёртку,
// которая правильно собирает worker как отдельный entry.

import * as Comlink from 'comlink';
import DbWorker from './worker?worker';
import type { DbApi } from './worker';

let proxy: Comlink.Remote<DbApi> | null = null;

export function db(): Comlink.Remote<DbApi> {
  if (!proxy) {
    const worker = new DbWorker();
    proxy = Comlink.wrap<DbApi>(worker);
  }
  return proxy;
}
